module.exports = __webpack_public_path__ + "1d4cf2eb9001b6bf8dd999e04f541b3f.svg";